import { Check, Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGS, useI18n } from "@/i18n/I18nContext";

export const LanguageMenu = () => {
  const { lang, setLang, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-neutral-300 transition-colors duration-200 hover:text-[var(--gold-bright)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold)]"
        aria-label={t("lang.menu")}
        data-testid="lang-menu-trigger"
      >
        <Globe className="h-4 w-4 text-[var(--gold)]" />
        <span data-testid="lang-current">{lang.toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="card-carbon min-w-[11rem] rounded-xl" data-testid="lang-menu">
        <DropdownMenuLabel className="text-xs uppercase tracking-widest text-[var(--gold)]">{t("lang.menu")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => setLang(l.code)}
            className="flex cursor-pointer items-center justify-between gap-3"
            data-testid={`lang-option-${l.code}`}
          >
            <span dir={l.code === "ar" ? "rtl" : "ltr"}>{l.label}</span>
            {l.code === lang && <Check className="h-4 w-4 text-[var(--gold)]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
